import { createSlice } from '@reduxjs/toolkit';

const simpleViewSlice = createSlice({
    name: 'simpleView',
    initialState: {
        latestViews: [],
        curCategory: '',
        curTitle: '',
        curPath:''
    },
    reducers: {
        latestViewInfo: (state, action) => {
            state.latestViews = action.payload.latestViews;
        },
        currentViewInfo: (state, action) => {
            state.curCategory = action.payload.curCategory;
            state.curTitle = action.payload.curTitle;
            state.curPath = action.payload.curPath;
        },
        setSimpleViewInfo: (state, action) => {
            const {latestViews, curCategory, curTitle, curPath} = action.payload;
            state.latestViews = latestViews;
            state.curCategory = curCategory;
            state.curTitle = curTitle;
            state.curPath = curPath;
        }
    }
});

export const { latestViewInfo, currentViewInfo, setSimpleViewInfo } = simpleViewSlice.actions;
export default simpleViewSlice.reducer;
